export interface GooglePlacesAddressModel {
  streetNumber: string;
  street: string;
  city: string;
  regionCode: string;
  postalCode: string;
  addressLine2: string;
}

export interface GooglePlacesDetails {
  address: GooglePlacesAddressModel;
}

export interface GooglePlacesAddressFormValue {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  zip?: string;
}

export enum GooglePlacesFormFieldType {
  Street = 'street',
  City = 'city'
}